// Copyright 2021 Sorama B.V.

import { IWorkflowPropertyParser } from "libraries/WorkflowFramework/Interfaces/IWorkflowPropertyParser";

export class BooleanParser implements IWorkflowPropertyParser<boolean> {
    toWorkflowProperty(object: boolean): string {
        return object ? "true" : "false";
    }

    fromWorkflowProperty(str: unknown): boolean {
        if (typeof str === "string") {
            const stringValue = str as string;
            return stringValue.toLowerCase() === "true";
        }

        return !!str;
    }
}
